import type { HttpClient, HttpClientConfig } from "./types";
import { AxiosHttpClient } from "./implementations/axiosClient";

const API_URL: string = import.meta.env.VITE_API_URL;

// API Configuration
const API_CONFIG: HttpClientConfig = {
  baseURL: API_URL,
  timeout: 300000, //5 minutes
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

// Export the HttpClient interface using the singleton
export const getApi = (): HttpClient => AxiosHttpClient.getInstance(API_CONFIG);
